export type Slot = {
  label: string;
  start: string;
  end: string;
  type: string;
};

export const DAILYSLOTS = {
  dropMorning: "08:00",
  morning: "11:00",
  afternoon: "15:00",
};
